import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../../ui/TextField";
import Avatar from "../../../../../../../../../ui/Avatar";
import DataSelect from "../../../../../../../../../ui/DataSelect";
import useAddExistingForm from "./useAddExistingForm";

const defaultData = {
  firstName: "",
  lastName: "",
  middleName: "",
  email: "",
  phone: "",
  snils: "",
  birthday: "",
  sex: null,
  post: null,
  departmentId: null,
  startDate: "",
  register: false
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  avatarContainer: {
    display: "flex",
    alignItems: "left",
    '& span':{
      marginTop: 8,
      marginLeft: 8
    }
  }
});

const AddEmployeeForm = ({ disabled, onFormChange, classes, orgId }) => {
  const [data, setData] = React.useState(defaultData);
  const { dataSources, getForm } = useAddExistingForm();

  useEffect(() => {
    getForm(orgId);
  }, [orgId]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <DataSelect
        value={data.personId}
        onChange={value => onChange("personId", value.id)}
        dataSource={dataSources.persons}
        label="Сотрудник"
        renderTags={option => (
          <div className={classes.avatarContainer}>
            <Avatar imageId={option.avatar} />
            <span>{option.name}</span>
          </div>
        )}
        renderOption={option => (
          <div className={classes.avatarContainer}>
            <Avatar imageId={option.avatar} />
            <span>{option.name}</span>
          </div>
        )}
      />
      <DataSelect
        value={data.departmentId}
        onChange={value => onChange("departmentId", value.id)}
        label="Подразделение"
        dataSource={dataSources.departments}
      />
      <DataSelect
        value={data.post}
        onChange={value => onChange("post", value.id)}
        label="Должность"
        dataSource={dataSources.posts}
      />
      <Grid container>
        <Grid item xs={4}>
          <TextField
            required
            value={data.startDate}
            onChange={e => onChange("startDate", e.target.value)}
            label="Дата вступления в должность"
            disabled={disabled}
            type="date"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(AddEmployeeForm);
